import Vue from 'vue'
import App from './App.vue'
import router from './router'
import serviceContainer from './services/service-container'

import Buefy from 'buefy'
import './assets/scss/app.scss'

Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultFieldLabelPosition: 'inside'
})

Vue.config.productionTip = false

new Vue({
  provide: serviceContainer,
  router,
  render: h => h(App)
}).$mount('#app')
